import React from 'react'
import PropTypes from 'prop-types'
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	ResponsiveContainer,
	Cell,
} from 'recharts'
import ChartWrapper from './chartWrapper'
import PlaceholderChart from './placeholderChart'

const DEFAULT_COLORS = ['#3498db', '#2ecc71', '#f1c40f', '#e74c3c', '#9b59b6']

const UniversalBarChart = ({
	data,
	title,
	colors = DEFAULT_COLORS,
	xAxisKey = 'name',
	yKey = 'total',
	height = 300,
	emptyMessage = 'Nenhum dado encontrado.',
}) => {
	if (!data || data.length === 0) {
		return <PlaceholderChart title={title} message={emptyMessage} />
	}

	const getBarColor = (entry, index) => {
		if (!Array.isArray(colors) && typeof colors === 'object') {
			const key = entry[xAxisKey]
			return colors[key] || '#ccc'
		}

		if (Array.isArray(colors)) {
			return colors[index % colors.length]
		}

		return '#3498db'
	}

	return (
		<ChartWrapper title={title}>
			<ResponsiveContainer width="100%" height={height}>
				<BarChart
					data={data}
					margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
					<CartesianGrid strokeDasharray="3 3" vertical={false} />
					<XAxis dataKey={xAxisKey} />
					<YAxis />
					<Tooltip />
					<Bar dataKey={yKey} name="total">
						{data.map((entry, index) => (
							<Cell key={`cell-${index}`} fill={getBarColor(entry, index)} />
						))}
					</Bar>
				</BarChart>
			</ResponsiveContainer>
		</ChartWrapper>
	)
}

UniversalBarChart.propTypes = {
	data: PropTypes.array,
	title: PropTypes.string.isRequired,
	colors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	xAxisKey: PropTypes.string,
	yKey: PropTypes.string,
	height: PropTypes.number,
	emptyMessage: PropTypes.string,
}

export default UniversalBarChart
